import { RootState } from '~/store';

export const genrePageSelector = (state: RootState) => state.pagesFilter.genre;
